<form #form="ngForm" autocomplete="off">
    <ng-container *ngIf="jobBoard">
        <div class="app-grid">
            <mat-form-field class="columns-12">
                <mat-label>{{
                    'applicant-tracker.components.job-board-settings.urlForCustomCss' | appTranslate
                }}</mat-label>
                <input
                    type="text"
                    placeholder="https://www.example.com/styles.css"
                    #customCssUrl="ngModel"
                    name="customCssUrl"
                    [(ngModel)]="jobBoard.customCssUrl"
                    matInput
                />
                <mat-error *ngIf="customCssUrl.invalid">{{ customCssUrl.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-12">
                <mat-label>{{ 'applicant-tracker.components.job-board-settings.customCss' | appTranslate }}</mat-label>
                <textarea
                    placeholder="{{
                        'applicant-tracker.components.job-board-settings.customCssExample' | appTranslate
                    }}"
                    #customCss="ngModel"
                    name="customCss"
                    [(ngModel)]="jobBoard.customCss"
                    matInput
                >
                </textarea>
                <mat-error *ngIf="customCss.invalid">{{ customCss.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
    </ng-container>
</form>
